/* AUURAH Klaviyo guards v3.
   Guard 1 (scroll lock): removes stuck klaviyo-prevent-body-scrolling body class.
   Guard 2 (ghost overlay): after dismissing via NO THANKS, the fixed wrapper
   stays mounted: opacity 0, z-index 90000, pointer-events auto, full viewport,
   and its class often contains NO 'klaviyo' substring (kl-private-reset-css-*),
   so class matching fails. v3 walks the ANCESTOR chain of every Klaviyo-marked
   node and neutralises any invisible viewport-covering fixed/absolute layer.
   Flagged layers are restored automatically if Klaviyo reuses them visibly. */
(function () {
  var LOCK = 'klaviyo-prevent-body-scrolling';
  var FLAG = 'data-auurah-kl-neutralised';
  var flagged = [];
  var strikes = 0;
  var last = 0;

  function klEls() {
    return document.querySelectorAll(
      'div[class*="klaviyo"], div[data-testid^="klaviyo"], div[class*="kl-teaser"], div[id^="klaviyo"]'
    );
  }

  function isVisible(el) {
    var cs = window.getComputedStyle(el);
    if (cs.display === 'none' || cs.visibility === 'hidden') return false;
    if ((parseFloat(cs.opacity) || 0) < 0.05) return false;
    var r = el.getBoundingClientRect();
    return r.width >= 50 && r.height >= 50;
  }

  function coversViewport(el) {
    var r = el.getBoundingClientRect();
    var vw = window.innerWidth || 1;
    var vh = window.innerHeight || 1;
    return r.width >= vw * 0.5 && r.height >= vh * 0.5;
  }

  function ghostState(el) {
    var cs = window.getComputedStyle(el);
    if (cs.position !== 'fixed' && cs.position !== 'absolute') return 'live';
    if (isVisible(el)) return 'live';
    if (!coversViewport(el)) return 'live';
    return 'ghost';
  }

  function flagEl(el) {
    if (el.getAttribute(FLAG) === '1') {
      if (flagged.indexOf(el) === -1) flagged.push(el);
      return;
    }
    el.setAttribute(FLAG, '1');
    el.style.setProperty('pointer-events', 'none', 'important');
    flagged.push(el);
  }

  function unflagEl(el) {
    if (el.getAttribute(FLAG) !== '1') return;
    el.removeAttribute(FLAG);
    el.style.removeProperty('pointer-events');
  }

  function neutraliseGhosts() {
    var els = klEls();
    for (var i = 0; i < els.length; i++) {
      var node = els[i].parentElement;
      while (node && node !== document.body && node !== document.documentElement) {
        if (ghostState(node) === 'ghost') flagEl(node);
        node = node.parentElement;
      }
    }
    for (var j = flagged.length - 1; j >= 0; j--) {
      var el = flagged[j];
      if (!el.isConnected) { flagged.splice(j, 1); continue; }
      if (ghostState(el) !== 'ghost') {
        unflagEl(el);
        flagged.splice(j, 1);
      }
    }
  }

  function overlayOpen() {
    var els = klEls();
    for (var i = 0; i < els.length; i++) {
      var el = els[i];
      if (!isVisible(el)) continue;
      var cs = window.getComputedStyle(el);
      if (cs.position === 'fixed' || cs.position === 'absolute') return true;
      var node = el.parentElement;
      while (node && node !== document.body) {
        var pcs = window.getComputedStyle(node);
        if (pcs.position === 'fixed' || pcs.position === 'absolute') {
          if (isVisible(node)) return true;
        }
        node = node.parentElement;
      }
    }
    return false;
  }

  function audit() {
    neutraliseGhosts();
    if (!document.body || !document.body.classList.contains(LOCK)) { strikes = 0; return; }
    if (overlayOpen()) { strikes = 0; return; }
    strikes += 1;
    if (strikes >= 2) {
      document.body.classList.remove(LOCK);
      if (document.body.style.overflow === 'hidden') document.body.style.overflow = '';
      strikes = 0;
      try { window.dispatchEvent(new CustomEvent('auurah:scroll-unlocked')); } catch (e) {}
    }
  }

  function auditThrottled() {
    var now = Date.now();
    if (now - last < 200) return;
    last = now;
    audit();
  }

  function start() {
    try {
      var mo = new MutationObserver(function (muts) {
        for (var i = 0; i < muts.length; i++) {
          var m = muts[i];
          if (m.type === 'attributes') { auditThrottled(); return; }
          if (m.removedNodes && m.removedNodes.length) { auditThrottled(); return; }
        }
      });
      mo.observe(document.documentElement, { childList: true, subtree: true });
      mo.observe(document.body, { attributes: true, attributeFilter: ['class'] });
    } catch (e) {}
    setInterval(audit, 700);
    audit();
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start);
  else start();
})();
